module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "rightin"
    }
  }, [_c('div', {
    staticClass: "change-card"
  }, [_c('div', {
    staticClass: "card-nav"
  }, [_c('a', {
    staticClass: "back-a",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-items"
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-trash-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "share-a"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "create-time"
  }, [_vm._v("您创建于2017年4月20号 16:57")]), _vm._v(" "), _c('span', {
    staticClass: "create-location"
  }, [_vm._v("广顺北路 长宁区")]), _vm._v(" "), _c('div', {
    staticClass: "input-bar"
  }, [_c('div', {
    staticClass: "bar-inner"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "标题"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "edit-text",
    attrs: {
      "contenteditable": ""
    }
  }, [_vm._v("\n            我在测试\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "edit-text",
    attrs: {
      "contenteditable": ""
    }
  }, [_vm._v("\n            手都酸了达芙妮色地方\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "div-image"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image.png")
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "add-tag"
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("添加标签")])])]), _vm._v(" "), _c('foot-bar')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02632c46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/updateCard.vue
// module id = 46
// module chunks = 0